import { applyMiddleware, combineReducers, createStore } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import mainReducer from './MainReducer';

var middleware = [thunk, logger];

const rootRuducer = combineReducers({
  Webtracker: mainReducer,
});

const store = createStore(rootRuducer, applyMiddleware(...middleware));

export default store;
